import { get, post } from "@futuri/cloudsso-client/src/client/util";
import {
  LoginResult,
  LogoutResponse
} from "@futuri/cloudsso-client/src/client/types/api";
import { SET_PORTAL_DATA } from "./mutations";
import { POST } from "@futuri/cloudsso-client/src/client/types/productType";

export const logout = async ({
  rootGetters
}: {
  rootGetters: any;
}): Promise<void> => {
  const { baseUrl } = rootGetters;
  const { logoutUrl } = await post<any, LogoutResponse>(`${baseUrl}logout`, {});
  // location.href = '/auth/cognito'
  if (logoutUrl) {
    location.href = logoutUrl;
  }
};

export const fetchPortalData = async ({
  rootGetters,
  commit
}: {
  rootGetters: any;
  commit: any;
}): Promise<void> => {
  const { baseUrl } = rootGetters;
  const portalData = await get<LoginResult>(`${baseUrl}portalData`).catch(
    (ex: Error) => {
      console.warn("Exception getting portal data: ", ex);
      // location.href = "/auth/cognito";
    }
  );
  console.log("portalData: ", portalData);

  commit("SET_PORTAL_DATA", portalData);
};

export const requestPostLoginCredential = async ({
  rootGetters,
  getters
}: {
  rootGetters: any;
  getters: any;
}) => {
  const { baseUrl } = rootGetters;
  const currentCluster = getters.currentCluster(POST);
  if (!currentCluster) {
    return undefined;
  }
  const station = currentCluster.name;

  const { apiKey } = await post<any, any>(
    `${baseUrl}requestPostLoginCredential`,
    { station }
  );
  return apiKey;
};

export const setStation = ({ commit }: { commit: any }, station: string) => {
  commit("SET_STATION", station);
};
